export default "__VITE_PUBLIC_ASSET__72c42a2b__"